export default __webpack_public_path__ + "static/media/statistics.c3b45fbb.svg";